export default "__VITE_ASSET__ed96ce45__"